import { Entity } from '@backstage/catalog-model';
import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { RELEASE_MANAGER_ANNOTATIONS } from '@internal/backstage-plugin-release-manager-common';

import {
  releaseManagerApiRef,
  ReleaseManagerApiClient,
} from './api/ReleaseManagerApi';
import { rootRouteRef } from './routes';

export const releaseManagerPlugin = createPlugin({
  id: 'release-manager',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: releaseManagerApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory({ discoveryApi, fetchApi }) {
        return new ReleaseManagerApiClient({ discoveryApi, fetchApi });
      },
    }),
  ],
});

export const isReleaseManagerAvailable = (entity: Entity): boolean =>
  ['true', 'yes'].includes(entity?.metadata?.annotations?.[RELEASE_MANAGER_ANNOTATIONS.RELEASE_PROCESS] ?? '');

export const EntityReleaseContent = releaseManagerPlugin.provide(
  createRoutableExtension({
    name: 'EntityReleaseContent',
    component: () =>
      import('./components/EntityReleaseContent').then(
        m => m.EntityReleaseContent,
      ),
    mountPoint: rootRouteRef,
  }),
);
